'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { useServerInsertedHTML } from 'next/navigation';
import { useRef } from 'react';
export default function EmotionCacheProvider(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const isServerInserted = useRef(false);
  const [emotionCache] = React.useState(_temp);
  let t1;
  if ($[0] !== emotionCache) {
    t1 = () => {
      if (!isServerInserted.current) {
        isServerInserted.current = true;
        const names = Object.keys((emotionCache as any).inserted);
        const styles = Object.values((emotionCache as any).inserted).join(" ");
        if (names.length === 0 || styles.length === 0) {
          return null;
        }
        return <style data-emotion={`${emotionCache.key} ${names.join(" ")}`} dangerouslySetInnerHTML={{
          __html: styles
        }} />;
      }
    };
    $[0] = emotionCache;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useServerInsertedHTML(t1);
  let t2;
  if ($[2] !== children || $[3] !== emotionCache) {
    t2 = <CacheProvider value={emotionCache}>{children}</CacheProvider>;
    $[2] = children;
    $[3] = emotionCache;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
function _temp() {
  const cache = createCache({
    key: "next"
  });
  cache.compat = true;
  return cache;
}